import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConsultationHistoryRoutingModule } from './consultation-history-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { MomentModule } from 'angular2-moment';
import { ConsultationHistoryComponent } from './consultation-history.component';
import { TravelAgendaComponent } from './travel-agenda/travel-agenda.component';
import { MedicalConditionComponent } from './medical-condition/medical-condition.component';
import { VaccinationComponent } from './vaccination/vaccination.component';
import { AttachmentComponent } from './attachment/attachment.component';
import { FullAuditTrailComponent } from './full-audit-trail/full-audit-trail.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { LabTestComponent } from './lab-test/lab-test.component';
import { NoteComponent } from './note/note.component';
import { PrescriptionComponent } from './prescription/prescription.component';
import { PriorityAuditTrailComponent } from './priority-audit-trail/priority-audit-trail.component';
import { PatientInfoAuditTrailComponent } from './patient-info-audit-trail/patient-info-audit-trail.component';
import { MedicalConditionHistoryPopupComponent } from './medical-condition/medical-condition-popup.component';
import { MdProgressSpinnerModule, MdAutocompleteModule } from '@angular/material';
import { NewMedicalConditionPopupComponent } from './medical-condition/new-medical-condition-popup.component';
import { RecordPreviousVaccinePopupComponent } from './vaccination/record-vaccination-popup.component';
import { AddVaccinationPopupComponent } from './vaccination/add-vaccination-popup.component';
import { PrescriptionPopupComponent } from './prescription/prescription-popup.component';
import { LabTestPopupComponent } from './lab-test/lab-test-popup.component';
import { PatientInformationComponent } from '../centre/manage-patient-user/patient-information.component';
import { PatientInfoAuditTrailService } from './patient-info-audit-trail/patient-info-audit-trail.service';
// import { NgxEditorModule } from 'ngx-editor';
import { QuillEditorModule } from 'ngx-quill-editor';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ConsultationHistoryRoutingModule,
    SharedModule,
    MomentModule,
    MdProgressSpinnerModule,
    MdAutocompleteModule,
    //NgxEditorModule,
    QuillEditorModule
  ],
  declarations: [
    ConsultationHistoryComponent,
    TravelAgendaComponent,
    MedicalConditionComponent,
    VaccinationComponent,
    AttachmentComponent,
    FullAuditTrailComponent,
    InvoiceComponent,
    LabTestComponent,
    NoteComponent,
    PrescriptionComponent,
    PriorityAuditTrailComponent,
    PatientInfoAuditTrailComponent,
    MedicalConditionHistoryPopupComponent,
    NewMedicalConditionPopupComponent,
    RecordPreviousVaccinePopupComponent,
    AddVaccinationPopupComponent,
    PrescriptionPopupComponent,
    LabTestPopupComponent
  ],
  entryComponents: [
    MedicalConditionHistoryPopupComponent,
    NewMedicalConditionPopupComponent,
    RecordPreviousVaccinePopupComponent,
    AddVaccinationPopupComponent,
    PrescriptionComponent,
    PrescriptionPopupComponent,
    LabTestPopupComponent
  ],
  exports: [TravelAgendaComponent]
})
export class ConsultationHistoryModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/consultation-history.module.ts